module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"add":"Hinzufügen","back":"Zurück","newFoodTruck":"Neuer Foodtruck","newPartner":"Neuer Partner","thereAreItemsThatRequireYourAttention":"Es gibt Felder, die Ihre Aufmerksamkeit erfordern."},"en":{"add":"Add","back":"Back","newFoodTruck":"New food truck","newPartner":"New partner","thereAreItemsThatRequireYourAttention":"There are items that require your attention."}}')
  delete Component.options._Ctor
}
